import React from 'react';
import { MapView } from '../Map';
import { DateTimeSelector, CompareButton, DisplayModeSelector } from '../Controls';
import Legend from '../Legend';
import './styles.css';

const CompareLayout = () => {
  return (
    <div className="compare-layout">
      {/* Split map views - full height */}
      <div className="compare-maps">
        {/* Left map (View 1) */}
        <div className="compare-map-panel">
          <div className="compare-map-wrapper">
            <MapView viewId={1} />
          </div>
          <div className="compare-map-controls">
            <DateTimeSelector viewId={1} />
          </div>
        </div>

        {/* Divider */}
        <div className="compare-divider" />

        {/* Right map (View 2) */}
        <div className="compare-map-panel">
          <div className="compare-map-wrapper">
            <MapView viewId={2} />
          </div>
          <div className="compare-map-controls">
            <DateTimeSelector viewId={2} />
          </div>
        </div>
      </div>

      {/* Floating controls overlay */}
      <div className="compare-floating-controls">
        {/* Top-left: Display mode selector */}
        <div className="compare-top-left">
          <DisplayModeSelector />
        </div>

        {/* Top-right: Exit Compare button */}
        <div className="compare-top-right">
          <CompareButton />
        </div>

        {/* Bottom-right: Legend */}
        <div className="compare-bottom-right">
          <Legend />
        </div>
      </div>
    </div>
  );
};

export default CompareLayout;
